import {Component, ElementRef, Input, NgZone, OnInit} from '@angular/core';
import {Tools} from "linkurious-shared";

@Component({
  selector: 'form',
  template: `<ng-content></ng-content>`
})
export class FormComponent implements OnInit {

  @Input() tabIndex: number = 0;

  constructor(private _elementRef: ElementRef, private _zone: NgZone) {}

  ngOnInit() {
    let field = this._elementRef.nativeElement.getElementsByClassName('form__field')[this.tabIndex];
    if ( field ) {
      // search for regular inputs (input / select / text-area)
      for ( let i = 0; i < field.children.length; ++i ) {
        if ( Tools.isDefined(field.children[i].form )) {
          this.focus(field.children[i]);
          break;
        }
      }
    }
  }

  /**
   * Focus the targeted input
   */
  private focus(el: HTMLFormElement) {
    this._zone.runOutsideAngular(() => {
      setTimeout(() => {
        el.focus();
      }, 50);
    });
  }
}
